import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useStyles from './squareOutlineSVG.styles';
/* eslint no-tabs: ['error', { allowIndentationTabs: true }] */

const DEFAULT_ICON_SIZE = 53;
const BUTTON_BASE_WIDTH = 192;

const SquareMonoSVG = (props) => {
    const classes = useStyles();
    const {
        width,
        text,
        iconSize,
        onTextMatrixChange,
    } = props;
    const textRef = useRef();
    const [transformMatrix, setTransformMatrix] = useState('matrix(1 0 0 1 58.5319 28.4999)');

    useEffect(() => {
        if (textRef.current) {
            const text = textRef.current;
            const tbox = text.getBBox();
            // Note: Always use the iconSize as an offset to center things accordingly
            const newX = (iconSize / 2) + ((BUTTON_BASE_WIDTH - tbox.width) / 2);
            const translation = 'matrix(1 0 0 1 ' + newX + ' 28.4999)'; // will be sent to the backend as textMatrix
            setTransformMatrix(translation);
        }
    }, [textRef.current, width, text]);

    useEffect(() => {
        onTextMatrixChange(transformMatrix);
    }, [transformMatrix]);

    return (
        <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
            viewBox='0 0 202.6 48' xmlSpace='preserve'>
            <g>
                <rect x='1' y='1' width='200.6' height='46' fill='none' stroke='#FFFFFF' strokeWidth='1'/>
            </g>
            <text ref={textRef} transform={transformMatrix} className={classNames([classes.st0, classes.st1, classes.st2])} >{text}</text>
            <defs>
                <linearGradient id='monoLinear1' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(-103,0,-0,-178.01613,164,57.752659)'>
                    <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
                    <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
                    <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
                </linearGradient>
                <linearGradient id='monoLinear2' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(104.098721,0,0,161.004363,59.901279,54.62662)'>
                    <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
                    <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
                    <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
                </linearGradient>
                <linearGradient id='monoLinear3' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(-103,0,-0,-178.785995,164,57.752659)'>
                    <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
                    <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
                    <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
                </linearGradient>
            </defs>
            <g transform='translate(10 14) scale(0.22)'>
                <g transform='translate(-287.009995 -55.65802)'>
                    <g transform='translate(263 3)'>
                        <g transform='matrix(1.027215,0,0,0.594346,-23.804988,100.522251)'>
                            <path d='M164,57.753C164,73.07 156.805,85.505 147.942,85.505L77.058,85.505C68.195,85.505 61,73.07 61,57.753C61,42.436 68.195,30 77.058,30L147.942,30C156.805,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear1)' }} />
                        </g>
                    </g>
                    <g transform='translate(263 3)'>
                        <g transform='matrix(0.919245,0,0,0.594346,-32.063975,67.532896)'>
                            <path d='M164,57.753C164,73.07 155.96,85.505 146.056,85.505L78.944,85.505C69.04,85.505 61,73.07 61,57.753C61,42.436 69.04,30 78.944,30L146.056,30C155.96,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear2)' }} />
                        </g>
                    </g>
                    <g transform='translate(263 3)'>
                        <g transform='matrix(1.027215,0,0,0.591787,-4.463251,34.904425)'>
                            <path d='M164,57.753C164,73.07 156.836,85.505 148.011,85.505L76.989,85.505C68.164,85.505 61,73.07 61,57.753C61,42.436 68.164,30 76.989,30L148.011,30C156.836,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear3)' }} />
                        </g>
                    </g>
                </g>
            </g>
        </svg>

    );
};

SquareMonoSVG.propTypes = {
    width: PropTypes.number,
    text: PropTypes.string,
    iconSize: PropTypes.number,
    onTextMatrixChange: PropTypes.func,
};

SquareMonoSVG.defaultProps = {
    width: 200,
    text: 'Sync to Calendar',
    iconSize: DEFAULT_ICON_SIZE,
    onTextMatrixChange: () => {},
};

export default SquareMonoSVG;
